import React from 'react'
import {
  FileText,
  Building,
  Calendar,
  CreditCard,
  User,
  Phone,
  MapPin,
  CheckCircle,
  IdCard
} from 'lucide-react'
import printJS from 'print-js'

const LandscapeInstallmentBookingSlip = ({
  installment,
  companyInfo,
  payment
}) => {
  if (!installment || !companyInfo || !payment) {
    return (
      <div className='flex justify-center items-center h-full'>Loading...</div>
    )
  }
  console.log('Installment Data:', installment)
  console.log('Company Info:', companyInfo)
  // Additional safety check for customer data

  // Create safe versions of the data
  // Extract society info safely
  const society = companyInfo?.soc || companyInfo?.society || {
    name: 'Society',
    location: 'N/A',
    society_image: null
  }
  const societyImage = society?.society_image || 'default-image.jpg'

  // Extract customer info safely
  const customer = installment?.customer_id || {}
  const customerName = typeof customer === 'object' ? customer.name : 'Customer'
  const contactInfo = customer?.contactInfo || { phone: 'N/A', address: 'N/A', cnic: 'N/A' }

  // Extract payment details for the specific plot
  const plotId = (installment?.plot_id?._id || installment?.plot_id)?.toString()
  const plotPaymentDetails = payment[plotId] || {
    totalPaidAmount: 0,
    totalPendingInstallmentsAmount: 0,
    totalPlotAmount: 0
  }

  const formatCNIC = cnic => {
    if (!cnic) return 'N/A'
    if (typeof cnic !== 'string') return 'N/A'
    return cnic.replace(/^(\d{5})(\d{7})(\d{1})$/, '$1-$2-$3')
  }

  const handlePrint = () => {
    const printWindow = window.open('', '_blank', 'width=800,height=600')

    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Installment Payment Slip</title>
        <style>
          @media print {
            @page { 
              size: A4 portrait; 
              margin: 8mm; 
            }
            body { margin: 0; }
            .no-print { display: none !important; }
          }
          body { 
            font-family: 'Segoe UI', 'Arial', sans-serif; 
            margin: 0; 
            padding: 12px; 
            background: white;
            font-size: 11px;
            line-height: 1.4;
            color: #1f2937;
          }
          .header { 
            background: linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #1e40af 100%); 
            color: white; 
            padding: 12px; 
            border-radius: 8px; 
            margin-bottom: 12px; 
            box-shadow: 0 2px 8px rgba(30, 64, 175, 0.15);
            position: relative;
            overflow: hidden;
          }
          .header::before {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 60px;
            height: 60px;
            background: rgba(255,255,255,0.1);
            border-radius: 50%;
            transform: translate(20px, -20px);
          }
          .header-content { 
            display: flex; 
            justify-content: space-between; 
            align-items: center; 
            position: relative;
            z-index: 1;
          }
          .society-info { 
            display: flex; 
            align-items: center; 
          }
          .society-logo { 
            width: 40px; 
            height: 40px; 
            border-radius: 8px; 
            margin-right: 10px; 
            border: 2px solid rgba(255,255,255,0.2); 
            box-shadow: 0 1px 4px rgba(0,0,0,0.1);
          }
          .invoice-info { 
            text-align: right; 
            background: rgba(255,255,255,0.15); 
            padding: 8px 12px; 
            border-radius: 6px; 
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255,255,255,0.2);
          }
          .content-grid { 
            display: grid; 
            grid-template-columns: 1fr 1fr 1fr; 
            gap: 12px; 
            margin-bottom: 12px; 
          }
          .info-card { 
            background: white; 
            padding: 12px; 
            border-radius: 8px; 
            box-shadow: 0 2px 6px rgba(0,0,0,0.08); 
            border: 1px solid #e5e7eb;
            transition: all 0.3s ease;
          }
          .info-card:hover {
            box-shadow: 0 3px 12px rgba(0,0,0,0.12);
            transform: translateY(-1px);
          }
          .info-item { 
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); 
            padding: 8px; 
            border-radius: 6px; 
            margin-bottom: 8px; 
            border: 1px solid #e2e8f0;
          }
          .info-label { 
            margin: 0; 
            color: #64748b; 
            font-size: 9px; 
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          }
          .info-value { 
            margin: 2px 0 0; 
            font-weight: 600; 
            font-size: 10px;
            color: #1e293b;
          }
          .highlight-box {
            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            padding: 10px;
            border-radius: 6px;
            text-align: center;
            border: 2px solid #3b82f6;
            margin-bottom: 10px;
          }
          .highlight-box.green {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border-color: #10b981;
          }
          .highlight-box.orange {
            background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
            border-color: #f59e0b;
          }
          .signature-section { 
            display: grid; 
            grid-template-columns: 1fr 1fr; 
            gap: 12px; 
            margin-bottom: 12px; 
          }
          .signature-box { 
            background: white; 
            padding: 12px; 
            border-radius: 8px; 
            box-shadow: 0 2px 6px rgba(0,0,0,0.08); 
            text-align: center; 
            border: 1px solid #e5e7eb;
          }
          .signature-line { 
            height: 40px; 
            border-bottom: 2px solid #3b82f6; 
            margin-bottom: 8px;
            position: relative;
          }
          .signature-line::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 50%;
            transform: translateX(-50%);
            width: 30px;
            height: 2px;
            background: #3b82f6;
            border-radius: 1px;
          }
          .print-btn { 
            background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%); 
            color: white; 
            padding: 8px 16px; 
            border: none; 
            border-radius: 6px; 
            cursor: pointer; 
            font-size: 12px; 
            font-weight: 600;
            margin: 12px 0; 
            box-shadow: 0 2px 8px rgba(30, 64, 175, 0.3);
            transition: all 0.3s ease;
          }
          .print-btn:hover { 
            background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%); 
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(30, 64, 175, 0.4);
          }
          .terms-section {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            padding: 12px;
            border-radius: 8px;
            border: 1px solid #e2e8f0;
            margin-bottom: 12px;
          }
          .terms-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 8px;
          }
          .term-item {
            display: flex;
            gap: 8px;
            align-items: flex-start;
          }
          .term-number {
            background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
            color: white;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            font-size: 9px;
            font-weight: 600;
            box-shadow: 0 1px 3px rgba(59, 130, 246, 0.3);
          }
          h1 { font-size: 16px !important; font-weight: 700 !important; }
          h3 { font-size: 12px !important; margin-bottom: 8px !important; font-weight: 600 !important; color: #1e40af !important; }
          p { margin: 2px 0 !important; }
          .status-badge {
            display: inline-block;
            padding: 3px 8px;
            border-radius: 12px;
            font-size: 8px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          }
          .status-completed {
            background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
            color: #166534;
            border: 1px solid #22c55e;
          }
          .status-pending {
            background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
            color: #92400e;
            border: 1px solid #f59e0b;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="header-content">
            <div class="society-info">
              <img src="${societyImage}" alt="Society" class="society-logo" />
              <div>
                <h1 style="margin: 0; font-size: 16px; font-weight: 700; letter-spacing: -0.3px;">${society.name
      }</h1>
                <p style="margin: 2px 0 0; opacity: 0.9; font-size: 10px; font-weight: 500;">${society.location
      }</p>
              </div>
            </div>
            <div class="invoice-info">
              <p style="margin: 0; opacity: 0.9; font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.3px;">Installment Payment Slip</p>
              <p style="margin: 2px 0 0; font-size: 14px; font-weight: 700;">Invoice #${installment.receipt_no || 'N/A'
      }</p>
            </div>
          </div>
        </div>


        <!-- Main Content Grid -->
        <div class="content-grid">
          <!-- Customer Info -->
          <div class="info-card">
            <h3 style="font-size: 12px; margin-bottom: 8px; color: #1e40af; display: flex; align-items: center; gap: 6px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              Customer Details
            </h3>
            <div class="info-item">
              <p class="info-label">Full Name</p>
              <p class="info-value">${customerName
      }</p>
            </div>
            <div class="info-item">
              <p class="info-label">Contact Number</p>
              <p class="info-value">${contactInfo.phone || 'N/A'
      }</p>
            </div>
            <div class="info-item">
              <p class="info-label">CNIC Number</p>
              <p class="info-value">${formatCNIC(
        contactInfo.cnic
      )}</p>
            </div>
            <div class="info-item">
              <p class="info-label">Address</p>
              <p class="info-value">${contactInfo.address || 'N/A'
      }</p>
            </div>
          </div>


          <!-- Property Details -->
          <div class="info-card">
            <h3 style="font-size: 12px; margin-bottom: 8px; color: #1e40af; display: flex; align-items: center; gap: 6px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              Property Information
            </h3>
            <div class="info-item">
              <p class="info-label">Society</p>
              <p class="info-value" style="font-weight: 600; color: #1e40af;">${society?.name || 'Society'}</p>
            </div>
            <div class="info-item">
              <p class="info-label">Plot Details</p>
              <p class="info-value" style="font-weight: 600; color: #1e293b;">
                ${companyInfo?.plot_type || 'N/A'} - Plot #${companyInfo?.plot_number || 'N/A'
      }
              </p>
              <p class="info-value" style="color: #64748b; font-size: 9px;">${companyInfo?.block || 'N/A'
      }</p>
              <p class="info-value" style="color: #64748b; font-size: 9px;">${companyInfo?.size || 'N/A'
      } Marla</p>
            </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 10px;">
              <div class="highlight-box">
                <p style="margin: 0; color: #1e40af; font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px;">Installment</p>
                <p style="margin: 2px 0 0; font-weight: 700; font-size: 16px; color: #1e40af;">#${installment.installment_number || 'N/A'
      }</p>
              </div>
              <div class="highlight-box orange">
                <p style="margin: 0; color: #92400e; font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px;">Due Date</p>
                <p style="margin: 2px 0 0; font-weight: 700; color: #92400e;">${installment.due_date
        ? new Date(installment.due_date).toLocaleDateString('en-GB')
        : 'N/A'
      }</p>
              </div>
            </div>
          </div>

          <!-- Payment Details -->
          <div class="info-card">
            <h3 style="font-size: 12px; margin-bottom: 8px; color: #1e40af; display: flex; align-items: center; gap: 6px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                <line x1="1" y1="10" x2="23" y2="10"></line>
              </svg>
              Payment Details
            </h3>
            <div class="highlight-box green">
              <p style="margin: 0; color: #166534; font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px;">Total Amount</p>
              <p style="margin: 2px 0 0; font-weight: 700; font-size: 18px; color: #166534;">PKR ${(
        installment.amount || 0
      ).toFixed(2)}</p>
            </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
              <div class="info-item">
                <p class="info-label">Paid Amount</p>
                <p class="info-value">PKR ${(
        installment.paid_amount || 0
      ).toFixed(2)}</p>
              </div>
              <div class="info-item">
                <p class="info-label">${(installment.remaining_amount || 0) < 0 ? 'Excess/Advance' : 'Remaining'}</p>
                <p class="info-value" style="color: ${(installment.remaining_amount || 0) < 0 ? '#166534' : '#1e293b'};">
                  PKR ${Math.abs(installment.remaining_amount || 0).toFixed(2)}
                </p>
                ${(installment.remaining_amount || 0) > 0
        ? `<p style="margin: 2px 0 0; color: #64748b; font-size: 8px; font-style: italic;">
                      This remaining amount will be added to the next upcoming installment.
                     </p>`
        : (installment.remaining_amount || 0) < 0
          ? `<p style="margin: 2px 0 0; color: #166534; font-size: 8px; font-style: italic; font-weight: 600;">
                        Excess amount covering next month.
                       </p>`
          : ''
      }
              </div>
              <div class="info-item">
                <p class="info-label">Payment Date</p>
                <p class="info-value">${installment.payment_date
        ? new Date(installment.payment_date).toLocaleDateString(
          'en-GB'
        )
        : new Date().toLocaleDateString('en-GB')
      }</p>
              </div>
              <div class="info-item">
                <p class="info-label">Payment Method</p>
                <p class="info-value">${installment.payment_method || 'N/A'}</p>
              </div>
              <div class="info-item">
                <p class="info-label">Total Paid Amount</p>
                <p class="info-value">PKR ${(
        plotPaymentDetails.totalPaidAmount || 0
      ).toFixed(2)}</p>
              </div>
              <div class="info-item">
                <p class="info-label">Pending Installment Amount</p>
                <p class="info-value">PKR ${(
        plotPaymentDetails.totalPendingInstallmentsAmount || 0
      ).toFixed(2)}</p>
              </div>
              <div class="info-item">
                <p class="info-label">Total Plot Amount</p>
                <p class="info-value">PKR ${(
        plotPaymentDetails.totalPlotAmount || 0
      ).toFixed(2)}</p>
              </div>
            </div>
          </div>
        </div>

       <!-- Terms and Conditions -->
<div class="terms-section">
  <h3 style="font-size: 12px; margin-bottom: 8px; color: #1e40af; display: flex; align-items: center; gap: 6px;">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
    Terms & Conditions
  </h3>
      <div class="terms-grid">
      <div class="term-item">
        <div class="term-number">1</div>
        <p style="margin: 0; font-size: 9px; color: #4b5563; line-height: 1.3;">Payment must be made on or before the due date to avoid late payment charges.</p>
      </div>
      <div class="term-item">
        <div class="term-number">2</div>
        <p style="margin: 0; font-size: 9px; color: #4b5563; line-height: 1.3;">A late payment fee of 2% per month will be charged on overdue amounts.</p>
      </div>
       <div class="term-item">
        <div class="term-number">3</div>
        <p style="margin: 0; font-size: 9px; color: #4b5563; line-height: 1.3;">All payments should be made through authorized channels only.</p>
      </div>
       <div class="term-item">
        <div class="term-number">4</div>
        <p style="margin: 0; font-size: 9px; color: #4b5563; line-height: 1.3;">Installment receipts must be preserved and presented upon request.</p>
      </div>
       <div class="term-item">
        <div class="term-number">5</div>
        <p style="margin: 0; font-size: 9px; color: #4b5563; line-height: 1.3;">The company reserves the right to cancel the booking in case of three consecutive missed payments.</p>
      </div>
       <div class="term-item">
        <div class="term-number">6</div>
        <p style="margin: 0; font-size: 9px; color: #4b5563; line-height: 1.3;">Any changes in payment schedule must be approved by the management in writing.</p>
      </div>
       <div class="term-item">
        <div class="term-number">7</div>
        <p style="margin: 0; font-size: 9px; color: #4b5563; line-height: 1.3;">Bounced checks will incur additional processing charges.</p>
      </div>
       <div class="term-item">
        <div class="term-number">8</div>
        <p style="margin: 0; font-size: 9px; color: #4b5563; line-height: 1.3;">Transfer of property ownership is subject to full payment clearance.</p>
      </div>
   
  </div>
</div>

        <!-- Signatures -->
        <div class="signature-section">
          <div class="signature-box">
            <div class="signature-line"></div>
            <p style="margin: 6px 0 0; font-size: 11px; color: #64748b; font-weight: 500;">Customer Signature</p>
            <p style="margin: 2px 0 0; font-size: 9px; color: #94a3b8;">Date: ${new Date().toLocaleDateString(
        'en-GB'
      )}</p>
          </div>
          <div class="signature-box">
            <div class="signature-line"></div>
            <p style="margin: 6px 0 0; font-size: 11px; color: #64748b; font-weight: 500;">Company Representative</p>
            <p style="margin: 2px 0 0; font-size: 9px; color: #94a3b8;">Date: ${new Date().toLocaleDateString(
        'en-GB'
      )}</p>
          </div>
        </div>
        
        <div style="text-align: center; margin-top: 20px;">
          <button onclick="window.print()" class="print-btn no-print">
            Print Receipt
          </button>
        </div>
      </body>
      </html>
    `

    // Write content to the new window and print
    printWindow.document.write(printContent)
    printWindow.document.close()

    // Wait for content to load then print
    printWindow.onload = function () {
      printWindow.print()
      printWindow.close()
    }
  }

  return (
    <div className='bg-white w-full rounded-lg'>
      <div className='bg-blue-600 text-white p-4 flex justify-between items-center rounded-t-lg'>
        <div className='flex items-center space-x-3'>
          <img
            src={societyImage}
            alt='Society'
            className='w-10 h-10 rounded-full object-cover'
          />
          <div>
            <h1 className='text-xl font-bold'>{society.name}</h1>
            <p className='text-sm opacity-80'>{society.location}</p>
          </div>
        </div>
        <div className='text-right'>
          <p className='text-xs opacity-80'>Installment Payment Slip</p>
          <p className='text-lg font-semibold'>
            Invoice #{installment?.receipt_no || 'N/A'}
          </p>
        </div>
      </div>

      {/* Main Content in Landscape Layout */}
      <div className='grid grid-cols-3 gap-4 p-4 bg-gray-50'>
        {/* Customer Info Column */}
        <div className='col-span-1 space-y-3'>
          <div className='flex items-center space-x-2 bg-white p-2 rounded-xl shadow-sm'>
            <User className='text-blue-500 w-5 h-5' />
            <div>
              <p className='text-xs text-gray-500'>Customer Name</p>
              <p className='font-bold text-gray-800 text-sm'>
                {customerName}
              </p>
            </div>
          </div>
          <div className='flex items-center space-x-2 bg-white p-2 rounded-xl shadow-sm'>
            <Phone className='text-green-500 w-5 h-5' />
            <div>
              <p className='text-xs text-gray-500'>Contact Number</p>
              <p className='font-bold text-gray-800 text-sm'>
                {contactInfo.phone || 'N/A'}
              </p>
            </div>
          </div>
          <div className='flex items-center space-x-2 bg-white p-2 rounded-xl shadow-sm'>
            <MapPin className='text-red-500 w-5 h-5' />
            <div>
              <p className='text-xs text-gray-500'>Address</p>
              <p className='font-bold text-gray-800 text-sm'>
                {contactInfo.address || 'N/A'}
              </p>
            </div>
          </div>
          <div className='flex items-center space-x-2 bg-white p-2 rounded-xl shadow-sm'>
            <IdCard className='text-red-500 w-5 h-5' />
            <div>
              <p className='text-xs text-gray-500'>CNIC</p>
              <p className='font-bold text-gray-800 text-sm'>
                {formatCNIC(contactInfo.cnic)}
              </p>
            </div>
          </div>
        </div>

        {/* Property & Installment Details Column */}
        <div className='col-span-1 space-y-3'>
          <div className='flex items-center space-x-2 bg-white p-2 rounded-xl shadow-sm'>
            <Building className='text-purple-500 w-5 h-5' />
            <div>
              <p className='text-xs text-gray-500'>Property Details</p>
              <p className='font-bold text-gray-800 text-sm'>
                {companyInfo?.plot_type || 'N/A'} - Plot #{companyInfo?.plot_number || 'N/A'},{' '}
              </p>
              <p className='font-bold text-gray-800 text-sm'>
                {companyInfo?.block || 'N/A'}
              </p>
              <p className='font-bold text-gray-800 text-sm'>
                {companyInfo?.size || 'N/A'} Marla
              </p>
            </div>
          </div>

          <div className='grid grid-cols-3 gap-2'>
            <div className='bg-blue-50 p-2 rounded-xl text-center space-y-1'>
              <Calendar className='mx-auto text-blue-600 w-5 h-5' />
              <p className='text-xs text-gray-600'>Installment No.</p>
              <p className='font-bold text-gray-800 text-sm'>
                {installment?.installment_number || 'N/A'}
              </p>
            </div>
            <div className='bg-green-50 p-2 rounded-xl text-center space-y-1'>
              <CreditCard className='mx-auto text-green-600 w-5 h-5' />
              <p className='text-xs text-gray-600'>Total Amount</p>
              <p className='font-bold text-gray-800 text-sm'>
                PKR {(installment?.amount || 0).toFixed(2)}
              </p>
            </div>
            <div className='bg-orange-50 p-2 rounded-xl text-center space-y-1'>
              <FileText className='mx-auto text-orange-600 w-5 h-5' />
              <p className='text-xs text-gray-600'>Due Date</p>
              <p className='font-bold text-gray-800 text-sm'>
                {installment?.due_date ? new Date(installment.due_date).toLocaleDateString('en-GB') : 'N/A'}
              </p>
            </div>
          </div>
        </div>

        {/* Payment Details Column */}
        <div className='col-span-1 space-y-3 bg-gray-100 p-3 rounded-xl'>
          <h3 className='text-lg font-semibold text-gray-700 mb-2 flex items-center'>
            <CheckCircle className='mr-2 text-green-500 w-5 h-5' /> Payment
            Details
          </h3>
          {[
            {
              label: 'Total Amount',
              value: `PKR ${(installment?.amount || 0).toFixed(2)}`
            },
            {
              label: 'Paid Amount',
              value: `PKR ${(installment?.paid_amount || 0).toFixed(2)}`
            },
            {
              label: Number(installment?.remaining_amount || 0) < 0 ? 'Excess/Advance' : 'Remaining Amount',
              value: `PKR ${Math.abs(Number(installment?.remaining_amount || 0)).toFixed(2)}`,
              note:
                Number(installment?.remaining_amount || 0) > 0
                  ? 'This remaining amount will be added to the next upcoming installment.'
                  : Number(installment?.remaining_amount || 0) < 0
                    ? 'Excess amount covering next month.'
                    : null
            },
            {
              label: 'Payment Date',
              value: installment?.payment_date
                ? new Date(installment.payment_date).toLocaleDateString('en-GB')
                : new Date().toLocaleDateString('en-GB')
            },
            {
              label: 'Total Paid Amount',
              value: `PKR ${(plotPaymentDetails.totalPaidAmount || 0).toFixed(2)}`
            },
            {
              label: 'Total Pending Installment Amount',
              value: `PKR ${(plotPaymentDetails.totalPendingInstallmentsAmount || 0).toFixed(
                2
              )}`
            },
            {
              label: 'Total Plot Amount',
              value: `PKR ${(plotPaymentDetails.totalPlotAmount || 0).toFixed(2)}`
            }
          ].map(({ label, value, note }) => (
            <div
              key={label}
              className='bg-white p-2 rounded-xl flex flex-col shadow-sm'
            >
              <span className='text-xs text-gray-600'>{label}</span>
              <span className='font-bold text-gray-800 text-sm'>{value}</span>

              {note && (
                <div className='mt-2'>
                  <p className='text-gray-800 text-xs italic text-blue-600'>{note}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Signature Section */}
      <div className='flex justify-between p-4 border-t'>
        <div className='w-1/2 pr-2'>
          <div className='h-10 border-b border-gray-300'></div>
          <p className='text-xs text-gray-600 text-center mt-1'>
            Customer Signature
          </p>
        </div>
        <div className='w-1/2 pl-2'>
          <div className='h-10 border-b border-gray-300'></div>
          <p className='text-xs text-gray-600 text-center mt-1'>
            Company Representative
          </p>
        </div>
      </div>

      <div className='flex justify-end gap-4 mt-4 p-4'>
        <button
          onClick={handlePrint}
          className='px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 print-btn'
        >
          Print
        </button>
      </div>
    </div>
  )
}


export default LandscapeInstallmentBookingSlip
